import {
  Button,
  Callout,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Intent
} from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { dispatch, RootState } from 'src/store'
import buttonStyles from '../Button/button.scss'
import styles from './create-lecture-modal.scss'

const cx = classnames.bind({ ...styles, ...buttonStyles })

interface IProps
  extends Partial<ReturnType<typeof mapState>>,
    Partial<RouteComponentProps<any>> {
  isOpen: boolean
  onClose?: () => void
}

class CreateLectureModal extends React.Component<IProps> {
  public state = {
    lectureId: '',
    error: null
  }
  public handleCreateClick = (event: React.FormEvent) => {
    event.preventDefault()
    // TODO: do not use window.location to reload page
    const { lectureId } = this.state
    dispatch.lectures
      .createLecture(lectureId)
      .then((_: any) => window.location.replace(`/lectures/${lectureId}`))
      .catch((error: Error) => this.setState({ error }))
  }
  public handleLectureIdChange = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({ error: null, lectureId: event.currentTarget.value })
  }
  public render() {
    const { isOpen, onClose } = this.props
    const { error } = this.state
    return (
      <Dialog isOpen={isOpen} className={cx()}>
        <div className={Classes.DIALOG_HEADER}>開設講座</div>
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={this.handleCreateClick}>
            <FormGroup
              helperText="講座唯一識別碼，不可與其他人重複"
              label="講座 ID"
              labelFor="lecture-id"
            >
              <InputGroup
                large={true}
                autoFocus={true}
                placeholder="僅能使用英數與破折號(-)"
                onChange={this.handleLectureIdChange}
              />
            </FormGroup>
            <input type="submit" hidden={true} />
          </form>
          {error ? (
            <Callout
              title={(error as Error).message}
              intent="danger"
              icon="error"
            />
          ) : null}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={onClose}>Close</Button>
            <Button onClick={this.handleCreateClick} intent={Intent.PRIMARY}>
              Create
            </Button>
          </div>
        </div>
      </Dialog>
    )
  }
}

const mapState = ({ auth }: RootState) => ({
  error: auth.error
})

export default connect(mapState)(CreateLectureModal)



// WEBPACK FOOTER //
// ./src/components/CreateLectureModal/index.tsx